// extracted by mini-css-extract-plugin
module.exports = {"text":"GuestCommunication__text___1IICd","dark":"GuestCommunication__dark___1z1ln","call":"GuestCommunication__call___2fs6Y","phone":"GuestCommunication__phone___34Vkt"};